var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import uniqueId from 'lodash/uniqueId';
import join from 'lodash/join';
import ShopifyBuy from '../Shopify/ShopifyBuy';
import Store from '../../stores/store';
import ShopifyMoreOptions from '../Shopify/ShopifyMoreOptions';
import { AttributeIcon, PlantSize, Zones } from '../../themes/icons/attributes';
export var setWaterIcons = function (attr) {
    var iconList = [];
    if (attr.length > 1) {
        var singleIcons_1 = [];
        var rangeIcons_1 = [];
        attr.forEach(function (item) {
            if (item === 'dry in winter'
                || item === 'dry when dormant'
                || item === 'dry in summer') {
                singleIcons_1.push(item);
            }
            else {
                rangeIcons_1.push(item);
            }
        });
        if (rangeIcons_1.length > 1) {
            var attr1 = rangeIcons_1[0];
            var attr2 = rangeIcons_1[rangeIcons_1.length - 1];
            var attr1Id = "".concat(attr1.replace(/ /g, '_'));
            var attr2Id = "".concat(attr2.replace(/ /g, '_'));
            var elem = (React.createElement("li", { key: uniqueId(attr1Id), className: "range" },
                React.createElement(AttributeIcon, { name: attr1Id, className: "icn top" }),
                React.createElement(AttributeIcon, { name: attr2Id, className: "icn bottom" }),
                React.createElement("span", { className: "label" },
                    attr1,
                    ' ',
                    "-",
                    ' ',
                    attr2)));
            iconList.push(elem);
        }
        else if (rangeIcons_1.length === 1) {
            var attrId = "".concat(rangeIcons_1[0].replace(/ /g, '_'));
            var elem = (React.createElement("li", { key: uniqueId(attrId), className: "single" },
                React.createElement(AttributeIcon, { name: attrId, className: "icn" }),
                React.createElement("span", { className: "label" }, rangeIcons_1[0])));
            iconList.push(elem);
        }
        if (singleIcons_1.length > 0) {
            var singleLi = singleIcons_1.map(function (item) {
                var attrId = "".concat(item.replace(/ /g, '_'));
                return (React.createElement("li", { key: uniqueId(attrId), className: "single single__water" },
                    React.createElement(AttributeIcon, { name: attrId, className: "icn" }),
                    React.createElement("span", { className: "label" }, item)));
            });
            iconList = iconList.concat(singleLi);
        }
    }
    else {
        var attrId = "".concat(attr[0].replace(/ /g, '_'));
        var elem = (React.createElement("li", { key: uniqueId(attrId), className: "single" },
            React.createElement(AttributeIcon, { name: attrId, className: "icn" }),
            React.createElement("span", { className: "label" }, attr[0])));
        iconList.push(elem);
    }
    return iconList;
};
export var setSunIcons = function (attr) {
    if (attr.length > 1) {
        var attr1 = attr[0];
        var attr2 = attr[attr.length - 1];
        var attr1Id = "".concat(attr1.replace(/ /g, '_'));
        var attr2Id = "".concat(attr2.replace(/ /g, '_'));
        var elem_1 = (React.createElement("li", { key: uniqueId(attr1Id), className: "range" },
            React.createElement(AttributeIcon, { name: attr1Id, className: "icn top" }),
            React.createElement(AttributeIcon, { name: attr2Id, className: "icn bottom" }),
            React.createElement("span", { className: "label" },
                attr1,
                ' ',
                "-",
                ' ',
                attr2)));
        return elem_1;
    }
    var attrId = "".concat(attr[0].replace(/ /g, '_'));
    var elem = (React.createElement("li", { key: uniqueId(attrId), className: "single" },
        React.createElement(AttributeIcon, { name: attrId, className: "icn" }),
        React.createElement("span", { className: "label" }, attr[0])));
    return elem;
};
var SearchResultsItem = /** @class */ (function (_super) {
    __extends(SearchResultsItem, _super);
    function SearchResultsItem(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            openOptions: false,
        };
        return _this;
    }
    SearchResultsItem.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var openOptions = this.state.openOptions;
        var _c = this.props, data = _c.data, onAddToShopifyCart = _c.onAddToShopifyCart, isAvailable = _c.isAvailable, index = _c.index;
        var relatedUrl = "/plants/".concat(data.django_pk, "/").concat(data.slug, "/");
        if (Store.isNursery && !isAvailable) {
            relatedUrl += "?nurseries=".concat(Store.nurserySlug);
        }
        var zones = data.zones_str;
        var mainTitle = null;
        var scientificName = null;
        var akaNames = [];
        mainTitle = data.primary_name;
        scientificName = data.scientific_name;
        akaNames = data.aka_names;
        var scientificNameEl = null;
        if (scientificName) {
            scientificNameEl = (React.createElement("p", { className: "plant__name_scientific" },
                "Scientific Name:",
                ' ',
                scientificName));
        }
        var plantType = data.plant_type;
        var height = data.dimensions.H;
        var width = data.dimensions.W;
        var plantSize;
        var heightEl;
        var widthEl;
        if (height) {
            heightEl = (React.createElement("p", null,
                React.createElement("span", { className: "key" }, "Height: "),
                React.createElement("span", { className: "value" }, height)));
        }
        if (width) {
            widthEl = (React.createElement("p", null,
                React.createElement("span", { className: "key" }, "Width: "),
                React.createElement("span", { className: "value" }, width)));
        }
        if (height || width) {
            plantSize = (React.createElement("div", { className: "plant__size" },
                React.createElement("h3", null,
                    React.createElement(PlantSize, { className: "icn" }),
                    "Size"),
                heightEl,
                widthEl));
        }
        var plantPhoto;
        var panelClass = 'panel searchpage__result';
        if (data.photo !== '') {
            plantPhoto = (React.createElement("a", { href: relatedUrl, title: mainTitle, className: "plant_name_link" },
                React.createElement("div", { className: "plant__photo" },
                    React.createElement("picture", null,
                        React.createElement("source", { type: "image/webp", srcSet: data.photo_webp }),
                        React.createElement("source", { type: "image/jpeg", srcSet: data.photo }),
                        React.createElement("img", { loading: index === 0 ? 'eager' : 'lazy', src: data.photo, alt: data.photo_description })),
                    React.createElement("div", { className: "plant__photo_hover" },
                        React.createElement("span", null, "View Plant")))));
        }
        else {
            panelClass += ' noPhoto';
            plantPhoto = (React.createElement("a", { href: relatedUrl, title: mainTitle, className: "plant_name_link" },
                React.createElement("div", { className: "plant__photo no_photo" },
                    React.createElement("div", { className: "plant__photo_hover" },
                        React.createElement("span", null, "View Plant")))));
        }
        var buyBtn = (React.createElement(ShopifyBuy, { setOpenOptions: function (value) { return _this.setState({ openOptions: value }); }, plant: data, onAddToShopifyCart: onAddToShopifyCart, mainTitle: mainTitle, isAvailable: isAvailable }));
        var waterElem = null;
        var sunElem = null;
        if (((_a = data.water_needs) === null || _a === void 0 ? void 0 : _a.length) > 0)
            waterElem = setWaterIcons(data.water_needs);
        if (((_b = data.sun_exposure) === null || _b === void 0 ? void 0 : _b.length) > 0)
            sunElem = setSunIcons(data.sun_exposure);
        return (React.createElement("div", { className: panelClass },
            React.createElement("div", { className: "plant__name_cont" },
                React.createElement("h2", { className: "pdp_related__title" },
                    React.createElement("a", { href: relatedUrl, title: mainTitle, onBlur: function () { }, onFocus: function () { } }, mainTitle))),
            React.createElement("div", { className: "plant__name_aka" },
                scientificNameEl,
                React.createElement("p", null, akaNames.length > 0 && [
                    React.createElement("span", { key: 0 }, "aka "),
                    join(akaNames, ', '),
                ])),
            React.createElement("div", { className: "plant__detail" },
                React.createElement("div", { className: "plant__info " },
                    React.createElement("div", { className: "plant__type" },
                        React.createElement("h3", null,
                            React.createElement(AttributeIcon, { name: "attr1", className: "icn" }),
                            "Plant Type"),
                        React.createElement("p", null, plantType.replace(/\b[a-z]/g, function (x) { return x.toUpperCase(); }))),
                    React.createElement("div", { className: "plant__zones" },
                        React.createElement("h3", null,
                            React.createElement(Zones, { className: "icn" }),
                            "Zones"),
                        React.createElement("p", null, zones)),
                    plantSize),
                React.createElement("div", { className: "plant__info_single" },
                    React.createElement("ul", { className: "plant__info_needs" },
                        sunElem,
                        waterElem))),
            plantPhoto,
            buyBtn,
            openOptions && (React.createElement(ShopifyMoreOptions, { openOptions: openOptions, setOpenOptions: function (value) { return _this.setState({ openOptions: value }); }, djangoPk: data.django_pk, variants: data.variants.filter(function (variant) { return variant.available; }), affiliatedLinks: data.affiliated_links, onAddToShopifyCart: onAddToShopifyCart, partnersData: data.nurseries, plantTitle: mainTitle }))));
    };
    SearchResultsItem = __decorate([
        observer
    ], SearchResultsItem);
    return SearchResultsItem;
}(React.Component));
export default SearchResultsItem;
